import List from './List';
import Views from './Views';
import Formula from './Formula';
import File from './File';
import Login from './Login';
import Packs from './Packs';
import Items from './Items';
import User from './User';
import Account from './Account';
import Config from './Config';
import MailMerge from "./MailMerge"
import Comments from './Comments';
import EventHandlers from './EventHandlers';
import Assistant from './Assistant';
import ListRoles from './ListRoles';
import Record from './Record';
import WebSockets from './WebSockets';

const ApiClient = {
    Record,
    List,
    Views,
    Formula,
    File,
    Login,
    Packs,
    Items,
    User,
    Account,
    Config,
    MailMerge,
    Comments,
    EventHandlers,
    Assistant,
    ListRoles,
    WebSockets
};

export default ApiClient;
// export List;
// export Views;